module.exports = __webpack_public_path__ + "img/coupon_6.634d93fe.png";